import styled from "styled-components";
import {Image} from "@chakra-ui/core/dist";

export const ImageSS = styled(Image)`
  border-radius: 0.3em;
  box-shadow: 0 2px 12px 4px rgba(0,5,10,0.2);  
`;
